import i18next from "i18next";
import { initReactI18next } from "react-i18next";

//Import all translation files
import English from "./translation/English.json";
import Italian from "./translation/Italian.json";
import Albanian from "./translation/Albanian.json";
import German from "./translation/German.json";
import Spanish from "./translation/Spanish.json";
import Polish from "./translation/Polish.json";
import Ukrainian from "./translation/Ukrainian.json"

const resources = {
    en: {
        translation: English,
    },
    it: {
        translation: Italian,
    },
    sq: {
        translation: Albanian,
    },
    de: {
        translation: German,
    },
    es: {
        translation: Spanish,
    },
    pl: {
        translation: Polish,
    },
    ukr: {
        translation: Ukrainian,
    },
}

i18next.use(initReactI18next)
    .init({
        resources,
        lng: "sq", //default language
    });

export default i18next;